import React, { ReactElement } from 'react'
import { DocumentsManualInfoInput } from './components/DocumentsManualInfoInput/DocumentsManualInfoInput'
import { DocumentsManualInfoSelect } from './components/DocumentsManualInfoSelect/DocumentsManualInfoSelect'
import { ECompanyType } from 'utils/constants'
import { IDocumentsManualInfo } from '../../interface'
import { inputsProps } from '../../constants'
import { useDocumentsForm } from './hooks/useDocumentsManualInfo'
import { useTranslation } from 'react-i18next'
import './DocumentsManualInfo.scss'

export const DocumentsManualInfo = ({
  additionalData = { legal: false, fiscal: false },
  errors,
  touched
}: IDocumentsManualInfo): ReactElement => {
  const { t } = useTranslation()
  const documentsManualInfoTitle = t(`wizard.documents.manualInfo.title`)
  const { taxRegimesOptions } = useDocumentsForm(t)
  const { manualInfo } = inputsProps(t)

  return (
    <div className='documents-manual-info'>
      <h4 className='documents-manual-info-title'>{documentsManualInfoTitle}</h4>
      <div className='documents-manual-info-form'>
        {manualInfo.map(field => {
          const isInputType = field.type === 'text' || field.type === 'date'
          const fiscalValidation = additionalData.fiscal && field.fieldType === ECompanyType.FISCAL
          const legalValidation = additionalData.legal && field.fieldType === ECompanyType.LEGAL

          if (fiscalValidation || legalValidation) {
            return isInputType ? (
              <DocumentsManualInfoInput key={field.name} field={field} errors={errors} touched={touched} />
            ) : (
              <DocumentsManualInfoSelect
                key={field.name}
                field={field}
                errors={errors}
                touched={touched}
                taxRegimesOptions={taxRegimesOptions}
              />
            )
          } else {
            return null;
          }
        })}
      </div>
    </div>
  )
}
